import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Primary UI component for user interaction
 */
const Button = ({
  children,
  color,
  disabled,
  fontColor,
  icon,
  id,
  inline,
  onClick,
  outline,
  small,
  style,
  type = 'button'
}) => {
  const visible_color = Colors[color || 'PRIMARY'].hex;
  const styles = {
    component: Object.assign(
      {},
      {
        height: small ? 30 : 40,
        lineHeight: small ? '28px' : '38px',
        textAlign: 'center',
        borderRadius: BorderRadius.DEFAULT,
        border: `1px solid ${visible_color}`,
        fontSize: small ? FontSizes.REGULAR : FontSizes.MEDIUM,
        fontWeight: FontWeights.MEDIUM,
        color: outline ? visible_color : fontColor || '#fff',
        background: outline ? 'transparent' : visible_color,
        cursor: disabled ? 'default' : 'pointer',
        padding: small ? '0px 10px' : '0px 30px',
        display: inline ? 'inline-block' : 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: disabled ? 0.5 : 1,
        whiteSpace: 'nowrap'
      },
      style
    ),
    btn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: small ? '30px' : '40px'
    }
  };

  if (icon && !children) {
    styles.component.width = small ? 30 : 40;
    styles.component.fontSize = small ? 18 : 24;
    styles.component.fontWeight = 500;
    styles.component.padding = 0;
  }

  const submitButton = () => {
    if (type !== 'submit') {
      return null;
    }

    return (
      <button style={{ display: 'none' }} type={type}>
        Submit
      </button>
    );
  };

  return (
    <>
      {submitButton()}
      <div id={id} onClick={disabled ? null : onClick} style={styles.component}>
        <div style={styles.btn}>
          {icon ? (
            <i
              className={`mdi mdi-${icon}`}
              style={{
                marginRight: children ? 8 : 0,
                fontSize: small && children ? 18 : 20
              }}
            />
          ) : null}
          {children}
        </div>
      </div>
    </>
  );
};

Button.propTypes = {
  color: PropTypes.oneOf(['GRAY', 'PRIMARY', 'SECONDARY', 'RED']),
  disabled: PropTypes.bool,
  fontColor: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.node,
  inline: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
  small: PropTypes.bool,
  type: PropTypes.string
};

export default Button;
